"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCourseConfig = exports.PharmacyTechnicianExam = exports.FsaHealthExam = exports.CourseConfigType = void 0;
const practiceProblems_1 = require("./practiceProblems");
const types_1 = require("./practiceProblems/types");
const types_2 = require("./api/websiteFrontendVsWebsiteBackend/accountMaintenance/types");
var CourseConfigType;
(function (CourseConfigType) {
    CourseConfigType["fsaHealth"] = "fsaHealth";
    CourseConfigType["pharmacyTechnician"] = "pharmacyTechnician";
})(CourseConfigType || (exports.CourseConfigType = CourseConfigType = {}));
var FsaHealthExam;
(function (FsaHealthExam) {
    FsaHealthExam["design_and_pricing"] = "design_and_pricing";
    FsaHealthExam["valuation_and_regulation"] = "valuation_and_regulation";
    FsaHealthExam["risk_mitigation"] = "risk_mitigation";
})(FsaHealthExam || (exports.FsaHealthExam = FsaHealthExam = {}));
var PharmacyTechnicianExam;
(function (PharmacyTechnicianExam) {
    PharmacyTechnicianExam["pharmacy_technician"] = "pharmacy_technician";
})(PharmacyTechnicianExam || (exports.PharmacyTechnicianExam = PharmacyTechnicianExam = {}));
const getCourseConfig = (courseConfigType) => COURSE_CONFIG_MAP[courseConfigType];
exports.getCourseConfig = getCourseConfig;
const COURSE_CONFIG_MAP = {
    [CourseConfigType.fsaHealth]: {
        type: CourseConfigType.fsaHealth,
        practiceProblemTypes: [
            practiceProblems_1.PracticeProblemType.SHORT_ANSWER,
            practiceProblems_1.PracticeProblemType.MULTI_PART,
        ],
        hasExcel: true,
        questionLanguages: [
            types_1.QuestionLanguage.calculate,
            types_1.QuestionLanguage.describe,
            types_1.QuestionLanguage.recommend,
            types_1.QuestionLanguage.compare,
            types_1.QuestionLanguage.list,
            types_1.QuestionLanguage.critique,
            types_1.QuestionLanguage.create,
            types_1.QuestionLanguage.assess,
            types_1.QuestionLanguage.define,
            types_1.QuestionLanguage.multiPart,
        ],
        hasNotecardHints: true,
        hasPreviousExamQuestionToggle: true,
        hasLearningObjectives: true,
        hasIsGoldStandardToggle: true,
        hasIsMathematicalToggle: true,
        hasIsConceptualToggle: true,
        hasIsSynthesisToggle: true,
        hasPracticeProblemHints: false,
        hasExplicitPracticeProblemTitle: true,
        defaultPracticeProblemPoints: 3,
        hasPracticeProblemCategories: false,
        hasSourceMaterialType: false,
        canGenerateContentFromSourceMaterial: false,
        hasPracticeProblemDifficultyScore: false,
        hasUnreleasedContent: false,
        hasVideos: false,
        // WEBSITE FRONTEND
        shouldShowOutlineSummary: true,
        shouldStarQuestionsInExam: true,
        shouldShowQuestionPointValue: true,
        referralPayout: 250,
        showOwlOnSplashPage: true,
        name: 'Just Enough Prep',
        allowWelcomePromoCode: true,
        includesExcelTemplates: true,
        defaultNotecardDeckShuffleType: types_2.NextNotecardMode.spacedRepetition,
        shouldRecentlySearchedTopicsInSearchModal: true,
        showFormulaSheetDownload: true,
    },
    [CourseConfigType.pharmacyTechnician]: {
        type: CourseConfigType.pharmacyTechnician,
        practiceProblemTypes: [practiceProblems_1.PracticeProblemType.MULTIPLE_CHOICE],
        hasExcel: false,
        questionLanguages: [],
        hasNotecardHints: true,
        hasPreviousExamQuestionToggle: false,
        hasLearningObjectives: false,
        hasIsGoldStandardToggle: false,
        hasIsMathematicalToggle: true,
        hasIsConceptualToggle: false,
        hasIsSynthesisToggle: false,
        hasPracticeProblemHints: false,
        hasExplicitPracticeProblemTitle: false,
        defaultPracticeProblemPoints: 1,
        hasPracticeProblemCategories: true,
        hasSourceMaterialType: true,
        canGenerateContentFromSourceMaterial: true,
        hasPracticeProblemDifficultyScore: true,
        hasUnreleasedContent: true,
        hasVideos: true,
        // WEBSITE-FRONTEND
        shouldShowOutlineSummary: false,
        shouldStarQuestionsInExam: false,
        shouldShowQuestionPointValue: false, // because they're all 1 pt
        referralPayout: 25,
        showOwlOnSplashPage: false,
        name: 'PassRxTech',
        allowWelcomePromoCode: false,
        includesExcelTemplates: false,
        defaultNotecardDeckShuffleType: types_2.NextNotecardMode.inCanonicalOrder,
        shouldRecentlySearchedTopicsInSearchModal: false,
        showFormulaSheetDownload: false,
    },
};
//# sourceMappingURL=courseConfig.js.map